'use client';

import React from 'react';

type FeedbackNavButtonsProps = {
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
  isNextDisabled?: boolean;
  isSubmitting?: boolean;
};

const FeedbackNavButtons = ({
  onBack,
  onNext,
  nextLabel = 'Avanti',
  isNextDisabled = false,
  isSubmitting = false,
}: FeedbackNavButtonsProps) => {
  return (
    <div className="it-feedback-nav">
      <button
        type="button"
        className="btn btn-sm it-feedback-nav-btn it-feedback-btn-back"
        onClick={onBack}
        disabled={isSubmitting}
      >
        Indietro
      </button>
      <button
        type="button"
        className="btn btn-primary btn-sm it-feedback-nav-btn"
        onClick={onNext}
        disabled={isNextDisabled || isSubmitting}
      >
        {isSubmitting ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
            Invio in corso…
          </>
        ) : (
          nextLabel
        )}
      </button>
    </div>
  );
};

export default FeedbackNavButtons;
